var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('table',{staticClass:"table table-striped table-bordered table-full-width",attrs:{"id":_vm.tableId}},[_c('tbody')])])])}
var staticRenderFns = []

export { render, staticRenderFns }